import { render, staticRenderFns } from "./AOG.vue?vue&type=template&id=70e1b87c&scoped=true&"
import script from "./AOG.vue?vue&type=script&lang=js&"
export * from "./AOG.vue?vue&type=script&lang=js&"
import style0 from "./AOG.vue?vue&type=style&index=0&id=70e1b87c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e1b87c",
  null
  
)

export default component.exports